import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconSound = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={14}
      fill="none"
      viewBox="0 0 18 14"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.790104 5.24628C1.22646 5.24628 1.5802 5.62208 1.5802 6.08566L1.5802 7.54145C1.5802 8.00503 1.22646 8.38083 0.790104 8.38083C0.353746 8.38083 7.39098e-06 8.00503 7.39098e-06 7.54145L7.39098e-06 6.08566C7.39098e-06 5.62208 0.353746 5.24628 0.790104 5.24628Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5894 5.8371C17.0258 5.8371 17.3795 6.2129 17.3795 6.67648L17.3795 6.94971C17.3795 7.41329 17.0258 7.78909 16.5894 7.78909C16.1531 7.78909 15.7993 7.41329 15.7993 6.94971L15.7993 6.67648C15.7993 6.2129 16.1531 5.8371 16.5894 5.8371Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.94878 2.52814C4.38514 2.52814 4.73888 2.90394 4.73888 3.36752L4.73888 10.2589C4.73888 10.7225 4.38514 11.0983 3.94878 11.0983C3.51242 11.0983 3.15868 10.7225 3.15868 10.2589L3.15868 3.36752C3.15868 2.90394 3.51242 2.52814 3.94878 2.52814Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4307 4.34906C13.8671 4.34906 14.2208 4.72486 14.2208 5.18844L14.2208 8.43775C14.2208 8.90133 13.8671 9.27713 13.4307 9.27713C12.9944 9.27713 12.6406 8.90133 12.6406 8.43775L12.6406 5.18844C12.6406 4.72486 12.9944 4.34906 13.4307 4.34906Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.10747 3.37378C7.54383 3.37378 7.89757 3.74958 7.89757 4.21316L7.89757 9.41276C7.89757 9.87633 7.54383 10.2521 7.10747 10.2521C6.67111 10.2521 6.31738 9.87633 6.31738 9.41276L6.31737 4.21316C6.31737 3.74958 6.67111 3.37378 7.10747 3.37378Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2661 3.46521e-08C10.7025 1.55143e-08 11.0562 0.375802 11.0562 0.839378L11.0562 12.7863C11.0562 13.2499 10.7025 13.6257 10.2661 13.6257C9.82979 13.6257 9.47605 13.2499 9.47605 12.7863L9.47605 0.839378C9.47605 0.375802 9.82979 5.37899e-08 10.2661 3.46521e-08Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
